
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'Рейсы', path: '/tms/trips' },
            { id: 2, name: 'ТТН', path: '/tms/ttns' },
        ]

        return { tabs }
    },
})
